import { Injectable } from '@angular/core';
import { Month } from '../models/monthe-name.model';

@Injectable({
    providedIn: 'root'
  })
  export class MonthsNameService {
    MonthList:Month[]=[{Id:1,Title:"فروردین"},
    {Id:2,Title:"اردیبهشت"},
    {Id:3,Title:"خرداد"},
    {Id:4,Title:"تیر"},
    {Id:5,Title:"مرداد"},
    {Id:6,Title:"شهریور"},
    {Id:7,Title:"مهر"},
    {Id:8,Title:"آبان"},        
    {Id:9,Title:"آذر"},
    {Id:10,Title:"دی"},
    {Id:11,Title:"بهمن"},
    {Id:12,Title:"اسفند"}]  
}